import { ICommand } from 'core-ts-types';
import { IPopupConfigService, IPopupObject } from './popup_config_service_type';

export class PopupConfigService implements IPopupConfigService {
  private _popupObject: IPopupObject;
  private _isActive: boolean;

  constructor(private phxMobileTrapFocus: any) {
    this.clearPopupObject();
  }

  getPopupObject() {
    return this._popupObject;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get title(): string {
    return this._popupObject.title;
  }

  get body(): string | undefined {
    return this._popupObject.body;
  }

  get acceptOnly(): boolean | undefined {
    return this._popupObject.acceptOnly;
  }

  get completeButtonText(): string | undefined {
    return this._popupObject.completeButtonText;
  }

  get cancelButtonText(): string | undefined {
    return this._popupObject.cancelButtonText;
  }

  accept(): void {
    if (this._popupObject.completeCallback) {
      this._popupObject.completeCallback();
    }
    this.activate();
  }

  cancel(): void {
    if (this._popupObject.cancelCallback) {
      this._popupObject.cancelCallback();
    }
    this.activate();
  }

  show(newPopupObject: IPopupObject): void {
    this.setPopupObject(newPopupObject);
    this.activate();
  }

  clearPopupObject(): void {
    this._isActive = false;
    this._popupObject = {
      title: '',
      body: undefined,
      completeButtonText: 'Accept',
      cancelButtonText: 'Cancel',
      completeCallback: undefined,
      cancelCallback: undefined,
      acceptOnly: false
    };
  }

  setPopupObject(newPopupObject: IPopupObject): void {
    this.clearPopupObject();
    this._popupObject = {
      ...this._popupObject,
      ...newPopupObject
    };
  }

  activate(): void {
    this._isActive = !this._isActive;
    if (this.isActive) {
      this.phxMobileTrapFocus.enableTrapFocus('popup-container');
    } else {
      this.phxMobileTrapFocus.disableTrapFocus('popup-container');
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/services/popup_config_service/popup_config_service.ts